import { LANDING_OFFER_FROM_META_KEY } from "../constants.js";
import { isOfMetaOrigin } from "../utils/marketing-url-params.js";
import { flightsSessionStore } from "@flights/web-api-utils-universal";
export default function useStoreLandingMetaOffer(offerToken) {
    const isMeta = isOfMetaOrigin();
    const storedOfferToken = flightsSessionStore.get(LANDING_OFFER_FROM_META_KEY);
    if (isMeta && !storedOfferToken) {
        flightsSessionStore.set(LANDING_OFFER_FROM_META_KEY, offerToken);
        return offerToken;
    }
    return storedOfferToken;
}
